"use strict";
//
// @Javi: Updated in 2022
// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
//
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Old textarea method to copy to the clipboard
 * @deprecated This is only for old browsers
 */
function fallbackCopy2clipboard(val) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
}
/**
 * Copy a text to the clipboard
 * This uses the navigator interface or the old textarea copy fallback
 */
async function copy2clipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopy2clipboard(text);
        return;
    }
    await navigator.clipboard.writeText(text);
}
exports.default = copy2clipboard;
